import { useParams, Link } from 'react-router-dom';
import Navbar from '../components/layout/Navbar';

export default function OrderSuccessPage() {
  const { id } = useParams();
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1 flex items-center justify-center px-4">
        <div className="card max-w-md w-full text-center py-12">
          <div className="text-6xl mb-6">🎉</div>
          <h1 className="text-2xl font-bold mb-2">Order Confirmed!</h1>
          <p className="text-gray-600 mb-2">
            Thank you for your purchase. We'll send you a confirmation email shortly.
          </p>
          <p className="text-xs text-gray-400 font-mono mb-8">Order ID: {id}</p>
          <div className="flex flex-col gap-3">
            <Link to="/shop"    className="btn-primary">Continue Shopping</Link>
            <Link to="/account" className="btn-secondary">View My Orders</Link>
          </div>
        </div>
      </main>
    </div>
  );
}
